import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

// TODO check if this must be in public folder
import translationDE from "./assets/locales/de/translation.json";
import translationEN from "./assets/locales/en/translation.json";

// TODO: Uncomment when AI works for de and en
// const fallbackLng = ["de"];
const availableLanguages = [
    // TODO: Uncomment when AI works for de and en
    // "de",
    "en",
];
const DEFAULT_LANGUAGE = "en";

const resources = {
    en: {
        translation: translationEN,
    },
    de: {
        translation: translationDE,
    },
};

i18n.use(Backend)
    .use(LanguageDetector) // detect user language
    .use(initReactI18next) // pass the i18n instance to react-i18next.
    .init({
        resources,
        // TODO: Uncomment when AI works for de and en
        // fallbackLng, // fallback language is german.
        detection: {
            checkWhitelist: true, // options for language detection
        },
        // TODO: Uncomment when AI works for de and en
        lng: DEFAULT_LANGUAGE, //localStorage.getItem("i18nextLng") ?? DEFAULT_LANGUAGE,
        debug: false,
        whitelist: availableLanguages,
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
